export default __webpack_public_path__ + "static/media/kitchen5-beforeA-768w.81a21c22.png";